import jwt_decode from 'jwt-decode';

type jwtType = { exp: number; iat: number; username: string };

/** Local clocks drift; a token is only treated as expired this long after exp. */
export const CLOCK_SKEW_SECONDS = 60;

export const decodeJwt = (token: string): jwtType | null => {
  try {
    return jwt_decode<jwtType>(token) || null;
  } catch {
    return null;
  }
};

export const isExpiredJwt = (
  token: string,
  skewSeconds = CLOCK_SKEW_SECONDS
) => {
  const jwt = decodeJwt(token);
  if (!jwt || typeof jwt.exp !== 'number') return true;
  const now = new Date().getTime() / 1000;
  return now >= jwt.exp + skewSeconds;
};
